import styled from 'styled-components';
import { PageHeader } from 'antd';

export default styled(PageHeader)`
  &.ant-page-header {
    padding: 0;
  }
`;